import React from "react";
import { Skill } from "../../types";
import "./MySkillsListElement.css";

interface MySkillsListElementProps {
    skill: Skill;
    lineHeight?: string;
    squareHeight?: string;
    squareWidth?: string;
    isLast?: boolean;
}

const MySkillsListElement = ({
    skill,
    isLast = false,
}: MySkillsListElementProps) => {
    return (
        <div className="my-skills-list-element-container">
            <div className="my-skills-list-element-left-container">
                <div className="my-skills-list-element-left-container-square"></div>
                {!isLast && (
                    <div className="my-skills-list-element-left-container-line"></div>
                )}
            </div>
            <div className="my-skills-list-element-right-container">
                <p className="my-skills-list-element-right-container-title">
                    {skill.name}
                </p>
                <p className="my-skills-list-element-right-container-description">
                    {skill.description}
                </p>
            </div>
        </div>
    );
};

export default MySkillsListElement;
